class Storage {
  /**
   * Get the value assosiated to the key from the local storage.
   * @param {string} key Value to get from local storage.
   */
  get = async (key: string): Promise<string | null> => {
    const result = await localStorage.getItem(key);
    return result ? JSON.parse(result) : null;
  };

  /**
   * Save the key/value to the local storage.
   * @param {string} key The key to save.
   * @param {string} value The value to save associated with the provided key.
   */
  set = async (key: string, value: string): Promise<void> => {
    await localStorage.setItem(key, JSON.stringify(value));
  };

  /**
   * Remove a key from the local storage.
   * @param {string} key The key to remove.
   */
  remove = async (key: string): Promise<void> => {
    await localStorage.removeItem(key);
  };
}

export default new Storage();
